import { Container, Grid } from '@mui/material'
import React from 'react'
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../Styles/style'

import telegram from "../../../assets/images/telegram.png"
import twitter from "../../../assets/images/twitter.png"
import pulselogo from "../../../assets/images/pulselogo.png"
import styled from '@emotion/styled'

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 }
`
const FeatureWrapper = styled.div`

height: 327px;
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`
const S7_Roadmap = () => {
    return (
        <div>
            <SectionWrapper p="4rem 0" id="roadmap">
                <Container maxWidth="xl">
                    {/* <SectionHeading p="20px 0" m="0" fs="70px" align="center" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0">
                        Contact
                    </SectionHeading> */}
                    <JOiningLinks data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0" src={pulselogo} />
                        <SectionSubHeading bg="linear-gradient(90deg, #FF0000 46%, #E619E6 50%, #0080FF 55%, #00EAFF 100%)">Disclaimer</SectionSubHeading>
                    <GridHEading container spacing={3} justifyContent="center">
                        <GridImage item xs={12} md={8} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">

                           
                            <P align="center"
                                p="40px 0"
                                m="0"
                                data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="600"
                                data-aos-duration="600"
                                data-aos-offset="0"
                            >
                                Investing in cryptocurrencies involves risks, including the potential loss of your investment. The value of cryptocurrencies can be highly volatile, and market conditions can change rapidly. We recommend conducting thorough research and consulting with financial professionals before making any investment decisions. However, with risk comes opportunity, and by embracing the potential of cryptocurrencies like $RHP on the Pulse Network, you can seize exciting possibilities and embrace the future of decentralized finance.
                            </P>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>

<a href="https://twitter.com/rhparody" target="blank" data-aos="zoom-in-up"
    data-aos-easing="ease-in"
    data-aos-delay="500"
    data-aos-duration="500"
    data-aos-offset="0">
    <JOiningLinks src={twitter} />
</a>
&nbsp;
&nbsp;
<a href="https://t.me/rhparody" target="blank" data-aos="zoom-in-up"
    data-aos-easing="ease-in"
    data-aos-delay="600"
    data-aos-duration="500"
    data-aos-offset="0">
    <JOiningLinks src={telegram} />
</a>
</div>
        </GridImage>

                    </GridHEading>
                </Container>

            </SectionWrapper>
        </div>
    )
}

export default S7_Roadmap